import React from 'react';

const ErrorAlert: React.FunctionComponent<any> = ({
	message,
}: {
	message: string;
}) => {
	return (
		<div className='error-alert' role='alert'>
			<span>
				<svg
					xmlns='http://www.w3.org/2000/svg'
					width='34'
					height='34'
					viewBox='0 0 34 34'
					fill='none'
				>
					<path
						d='M17 10.6V17M17 23.4H17.016M33 17C33 25.8366 25.8366 33 17 33C8.16344 33 1 25.8366 1 17C1 8.16344 8.16344 1 17 1C25.8366 1 33 8.16344 33 17Z'
						stroke='#EB5757'
						strokeWidth='2'
						strokeLinecap='round'
						strokeLinejoin='round'
					/>
				</svg>
			</span>
			<span>{message}</span>
		</div>
	);
};

export default ErrorAlert;
